import { Component, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';

import { Subscription, interval } from 'rxjs';
import { debounce, distinctUntilChanged } from 'rxjs/operators';

import { LoadingService } from '../loading/loading.service';
import { CoreConstants } from '../../../core/core.constants';
import { Store } from '@ngrx/store';
import { State } from '@shared/store/reducers';
import { appActions } from '@shared/store/actions';

@Component({
  standalone: false,
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements AfterViewInit, OnDestroy {

  @ViewChild('loadingModal', {static: false}) loadingModal: ElementRef;
  shouldDisplay = false;
  loading$: Subscription;

  constructor(
    private store: Store<State>,
    private loadingService: LoadingService
  ) {}

  ngAfterViewInit() {

    this.loading$ = this.loadingService.getLoadingStream()
      .pipe(
        distinctUntilChanged(),
        debounce(() => interval(CoreConstants.MODAL_WINDOW_TIMEOUT)),
      )
      .subscribe((showLoader: boolean) => {
        this.store.dispatch(appActions.setAppLoader(showLoader));
        this.toggle(showLoader);
      });
  }

  ngOnDestroy() {
    this.loading$.unsubscribe();
  }

  toggle(shouldDisplay: boolean) {
    this.loadingModal.nativeElement.open = !!shouldDisplay;
  }
}
